import React, { useContext, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import { Row, Col, Container, Button, Spinner, Form } from 'react-bootstrap';
import { getMyBidsAuctions, getAuctionDetails, convertTokentoNormalAmount } from '../components/blockchain functions/BlockchainFunctions';//API to get Data from wave account

import GetNFT from '../components/page-components/getNFT';
import { LoginContext } from "../context/LoginContext";
import { validGameNFT } from "../components/page-components/Random";
//icons
import bidIcon from '../components/assets/icons/auction.svg';
import openIcon from '../components/assets/icons/open-square.svg';
import closeIcon from '../components/assets/icons/close-square.svg';

const MyBids = () => {
  const history = useHistory();
  const [loading, setLoading] = useState(false);//Loading bar

  const [NFTdata, setNFTdata] = useState([]);
  const [loginData, setLoginData] = useContext(LoginContext);

  useEffect(async () => {
    if (loginData == null) { return; }
    if (loginData.walletAddress != "") {
      setLoading(true);
      let auctionList = await getMyBidsAuctions(loginData.walletAddress);
      let NFTdataList = [];
      console.log(auctionList);
      for (let i = 0; i < auctionList.length; i++) {
        let auctionId = auctionList[i];
        NFTdataList.push(await getAuctionDetails(auctionId));
      }

      setNFTdata(NFTdataList);
      console.log(NFTdataList);
      setLoading(false);
    }
  }, [loginData?.walletAddress]);


  return (
    <>
      <div className="page-heading">
        <h2><img style={{height:"3rem"}} src={bidIcon}/> My Bids</h2>
        <span>Here you can find all auction in which you had bid!</span>
      </div>
      <hr />

      <div className={loading ? 'parentDisable' : ''} width="100%">
        <br />
        <div className={loading ? 'overlay-box' : 'hide'}>
          <Spinner animation="border" role="status">
            <span className="visually-hidden">Loading...</span>
          </Spinner>
          <h4>wait till data is loading from blockchain</h4>
        </div>
        <Container>
          <Row>
            {NFTdata.map((data, key) => {
              return (
                validGameNFT(data.assetData.name) && (data.auctionOwner!=loginData?.walletAddress)?
                <Col sm={12}>
                <div className="auctionStatusImg"><img src={data.status == "open" ?openIcon:closeIcon}/></div>
                  <div className="nftData">
                    <Row>
                      <Col sm={4} onClick={e => history.push('/view-auction/' + data.auctionId)}>
                        <GetNFT nftName={data.assetData.name} />
                      </Col>
                      <Col sm={8}>
                        <Row onClick={e => history.push('/view-auction/' + data.auctionId)} >
                          <Col sm={6} className="details d-grid gap-1">
                            <div className="d-inline p-2 bg-dark text-white" style={{ height: "40px", borderRadius: "100px", textAlign: "center" }}><b>  Asset Details</b></div>
                            <p><span className="fw-bold">Asset Id</span> : {data.assetData.assetId} </p>
                            <p><span className="fw-bold">Name</span> : {data.assetData.name} </p>
                            <p><span className="fw-bold">Description</span> : {data.assetData.description} </p>
                            <p><span className="fw-bold">Created Date</span> : {new Date(data.assetData.issueTimestamp).toLocaleString()}</p>
                          </Col>
                          <Col sm={6} className="details d-grid gap-1">
                            <div className="d-inline p-2 bg-dark text-white" style={{ height: "40px", borderRadius: "100px", textAlign: "center" }}><b>  Auction Details</b></div>
                            <p><span className="fw-bold">AuctionId</span> : {data.auctionId} </p>
                            <p><span className="fw-bold">Initial price</span> : {convertTokentoNormalAmount(data.auctionStartPrice).substr(0,4)} </p>
                            <p><span className="fw-bold">Buyout Price</span> : {convertTokentoNormalAmount(data.auctionInstantPrice).substr(0,4)} </p>
                            <p><span className="fw-bold">OwnerId</span> : {data.auctionOwner} </p>
                            <p><span className="fw-bold">Auction Start Date</span> : {new Date(data.auctionStartedAt).toLocaleString()}</p>
                            <p><span className="fw-bold">Total Bids</span> : {data.totalBids}</p>
                          </Col>
                        </Row>
                        <Row>
                          <hr />
                          {data.status == "open" ?
                            <div style={{ padding: "6px", borderRadius: "100px", textAlign: "center", width: "100%", backgroundColor: "#198754", color: "white" }}>
                              Auction is still open.
                            </div> :
                            <div style={{ padding: "6px", borderRadius: "100px", textAlign: "center", width: "100%", backgroundColor: "#dc3545", color: "white" }}>
                              Auction is completed.
                            </div>
                          }
                        </Row>
                      </Col>
                    </Row>
                  </div>
                </Col>
                : <></>
              );
            })}
          </Row>
        </Container>
      </div>
    </>
  )
}

export default MyBids